export default __webpack_public_path__ + "assets/images/6b32bd80a75812612ec32f4fcc230dbf.svg";